
export default function numFromPx(style) {
  return Number(style.replace(/px/, ''));
}
